export default __webpack_public_path__ + "static/media/Neophyte's Robe of Consumed Souls.2d11a2a9.jpg";